import { useMemo } from 'react';

import { useChatsNavigationItem } from './useChatsNavigationItem';
import { useFavoritesNavigationItem } from './useFavoritesNavigationItem';
import { useMainPageNavigationItem } from './useMainPageNavigationItem';
import { useProfileNavigationItem } from './useProfileNavigationItem';
import { useSearchNavigationItem } from './useSearchNavigationItem';
import { IMobileNavigationItem } from '../../../types/mobileBottomNavigation';

export const useNavigationItems = (): IMobileNavigationItem[] => {
  const mainPageNavigationItem = useMainPageNavigationItem();

  const searchNavigationItem = useSearchNavigationItem();

  const favoritesNavigationItem = useFavoritesNavigationItem();

  const chatsNavigationItem = useChatsNavigationItem();

  const profileNavigationItem = useProfileNavigationItem();

  return useMemo(
    () => [
      mainPageNavigationItem,
      searchNavigationItem,
      favoritesNavigationItem,
      chatsNavigationItem,
      profileNavigationItem,
    ],
    [chatsNavigationItem, favoritesNavigationItem, mainPageNavigationItem, profileNavigationItem, searchNavigationItem],
  );
};
